import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { auth } from "../../../firebase";
import { fetchUserProfileFromFirestore } from "../../../services/profileService";
import { normalizePublicHandle, getPublicHandle } from "../../../utils/publicProfile";

export default function MyProfileRedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let isActive = true;

    async function resolveProfile() {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        navigate("/signin", { replace: true });
        return;
      }

      try {
        const profile = await fetchUserProfileFromFirestore(currentUser.uid);
        if (!isActive) return;

        const handle =
          normalizePublicHandle(profile?.publicHandle || "") ||
          getPublicHandle(profile?.userName || currentUser.email || currentUser.uid) ||
          currentUser.uid;

        navigate(`/u/${handle}`, { replace: true });
      } catch (err) {
        console.error("Failed to resolve current profile handle:", err);
        if (!isActive) return;
        navigate("/profile/edit", { replace: true });
      }
    }

    resolveProfile();

    return () => {
      isActive = false;
    };
  }, [navigate]);

  return (
    <Box sx={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
